module.exports = __webpack_public_path__ + "img/cooperate_logo.cc55f5eb.svg";